import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

// Lazy-load every page except Home → first paint downloads ~70% less JS
// and the rest only loads when the user navigates there.
const TrackPage     = lazy(() => import("@/pages/TrackPage"));
const FleetPage     = lazy(() => import("@/pages/FleetPage"));
const PricingPage   = lazy(() => import("@/pages/PricingPage"));
const ExperiencePage= lazy(() => import("@/pages/ExperiencePage"));
const GalleryPage   = lazy(() => import("@/pages/GalleryPage"));
const FaqPage       = lazy(() => import("@/pages/FaqPage"));
const ContactPage   = lazy(() => import("@/pages/ContactPage"));
const EventsPage    = lazy(() => import("@/pages/EventsPage"));
const AdvertisePage = lazy(() => import("@/pages/AdvertisePage"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-black">
    <div className="font-mono-display text-[10px] tracking-[0.3em] text-[#FF2D2D] uppercase animate-pulse">
      Loading...
    </div>
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route
              path="/*"
              element={
                <Suspense fallback={<RouteFallback />}>
                  <Routes>
                    <Route path="track" element={<TrackPage />} />
                    <Route path="fleet" element={<FleetPage />} />
                    <Route path="pricing" element={<PricingPage />} />
                    <Route path="experience" element={<ExperiencePage />} />
                    <Route path="gallery" element={<GalleryPage />} />
                    <Route path="faq" element={<FaqPage />} />
                    <Route path="contact" element={<ContactPage />} />
                    <Route path="events" element={<EventsPage />} />
                    <Route path="advertise" element={<AdvertisePage />} />
                    <Route path="*" element={<Home />} />
                  </Routes>
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,45,45,0.4)",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
